import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=086a099c&scoped=true&lang=pug"
import script from "./Window.vue?vue&type=script&lang=ts"
export * from "./Window.vue?vue&type=script&lang=ts"
import style0 from "./Window.vue?vue&type=style&index=0&id=086a099c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086a099c",
  null
  
)

export default component.exports